"use client";

import { useEffect } from "react";
import { trackEventWithCommonProps } from "@utils/eventTracker";
import { EventType } from "@utils/eventTracker";

interface BasePageTrackerProps {
  pageType: string;
  actionName?: string;
}

interface AdditionalProps {
  [key: string]: string | number | boolean | undefined | any;
}

interface PageTrackerProps extends BasePageTrackerProps {
  additionalProps?: AdditionalProps;
}

const PageTracker = ({
  pageType,
  actionName,
  additionalProps = {},
}: PageTrackerProps) => {
  const allProps = {
    ...additionalProps,
  };

  useEffect(() => {
    trackEventWithCommonProps("view", EventType.PAGE_EVENT, {
      pageType,
      additionalProps: {
        view_type: "view_page",
        view_name: actionName,
        ...allProps,
      },
    });
  }, [pageType, actionName, allProps]);

  return null;
};

export default PageTracker;
